import { BoxesInterface } from '../store/modules/boxes/types';

function formatDate(daysAgo: number, hour: number, minute: number): string {
  var d = new Date();
  d.setDate(d.getDate() - daysAgo);
  d.setHours(hour, minute, 0, 0);
  return d.toISOString();
}

function formatEndDate(startDate: string): string {
  var d = new Date(startDate);
  d.setMinutes(d.getMinutes() + 1);
  return d.toISOString();
}

var trade1Start = formatDate(0, 9, 30);
var trade2Start = formatDate(0, 10, 15);
var trade3Start = formatDate(0, 14, 0);
var trade4Start = formatDate(1, 10, 0);
var trade5Start = formatDate(1, 15, 30);

export var mockBoxesData: BoxesInterface = {
  ProfitAndLoss: {
    today: { profit: 235, loss: -100, total: 135, totalColor: '#4caf50' },
    week: { profit: 362, loss: -180, total: 182, totalColor: '#4caf50' },
    month: { profit: 752, loss: -300, total: 452, totalColor: '#4caf50' },
    year: { profit: 752, loss: -300, total: 452, totalColor: '#4caf50' },
    allTime: { profit: 752, loss: -300, total: 452, totalColor: '#4caf50' },
  },
  WinAndLoss: {
    today: { win: 2, loss: 1, draw: 0, percent: 66.67, percentColor: '#4caf50', name: 'Hoje' },
    week: { win: 4, loss: 2, draw: 0, percent: 66.67, percentColor: '#4caf50', name: 'Semana' },
    month: { win: 7, loss: 3, draw: 0, percent: 70, percentColor: '#4caf50', name: 'Mês' },
    year: { win: 7, loss: 3, draw: 0, percent: 70, percentColor: '#4caf50', name: 'Ano' },
    allTime: { win: 7, loss: 3, draw: 0, percent: 70, percentColor: '#4caf50', name: 'Total' },
  },
  Goals: {
    config: {
      tradeInWeekend: true,
      goalOfMonth: 500,
      currency: 'BRL',
      stopWin: 0,
      stopLoss: 0,
    },
    progressToday: 135,
    progressWeek: 182,
    progressMonth: 452,
  },
  MonthlyTracking: {
    labels: ['Sem 1', 'Sem 2', 'Sem 3', 'Sem 4'],
    values: [120, 185, 310, 452],
  },
  LastTrades: [
    { startDate: trade1Start, endDate: formatEndDate(trade1Start), asset: 'EUR/USD', instrument: 'Opções Binárias', result: 85, formattedResult: 85, color: '#4caf50' },
    { startDate: trade2Start, endDate: formatEndDate(trade2Start), asset: 'EUR/USD', instrument: 'Opções Binárias', result: -100, formattedResult: -100, color: '#f44336' },
    { startDate: trade3Start, endDate: formatEndDate(trade3Start), asset: 'Ouro', instrument: 'Forex', result: 150, formattedResult: 150, color: '#4caf50' },
    { startDate: trade4Start, endDate: formatEndDate(trade4Start), asset: 'EUR/USD', instrument: 'Opções Binárias', result: 127, formattedResult: 127, color: '#4caf50' },
    { startDate: trade5Start, endDate: formatEndDate(trade5Start), asset: 'Ouro', instrument: 'Forex', result: -80, formattedResult: -80, color: '#f44336' },
  ],
  BestAndWorseTrade: {
    bestTrade: { startDate: trade3Start, endDate: formatEndDate(trade3Start), asset: 'Ouro', instrument: 'Forex', investment: 200, result: 150 },
    worseTrade: { startDate: trade2Start, endDate: formatEndDate(trade2Start), asset: 'EUR/USD', instrument: 'Opções Binárias', investment: 100, result: -100 },
  },
  AssetsMostSucessful: [
    { asset: 'EUR/USD', percentOfWin: 60, qtyWin: 3, qtyLoss: 2, color: '#4caf50' },
    { asset: 'Ouro', percentOfWin: 50, qtyWin: 1, qtyLoss: 1, color: '#ff9800' },
  ],
  BestHours: [
    { hour: 9, percentOfWin: 100, qtyWin: 2, qtyLoss: 0, color: '#4caf50' },
    { hour: 10, percentOfWin: 50, qtyWin: 1, qtyLoss: 1, color: '#ff9800' },
    { hour: 14, percentOfWin: 100, qtyWin: 1, qtyLoss: 0, color: '#4caf50' },
    { hour: 15, percentOfWin: 0, qtyWin: 0, qtyLoss: 1, color: '#f44336' },
  ],
  BestDaysOfWeek: [
    { dayOfWeek: 1, qtyWin: 2, qtyLoss: 1, percentOfWin: 66.67, color: '#4caf50' },
    { dayOfWeek: 2, qtyWin: 1, qtyLoss: 0, percentOfWin: 100, color: '#4caf50' },
    { dayOfWeek: 3, qtyWin: 2, qtyLoss: 1, percentOfWin: 66.67, color: '#4caf50' },
    { dayOfWeek: 5, qtyWin: 2, qtyLoss: 1, percentOfWin: 66.67, color: '#4caf50' },
  ],
  DailyCalendar: [
    { date: formatDate(0, 0, 0).slice(0, 10), total: 135, tradeCount: 3, profit: 235, loss: -100, winCount: 2, lossCount: 1, drawCount: 0 },
    { date: formatDate(1, 0, 0).slice(0, 10), total: 47, tradeCount: 2, profit: 127, loss: -80, winCount: 1, lossCount: 1, drawCount: 0 },
    { date: formatDate(2, 0, 0).slice(0, 10), total: -50, tradeCount: 1, profit: 0, loss: -50, winCount: 0, lossCount: 1, drawCount: 0 },
    { date: formatDate(4, 0, 0).slice(0, 10), total: 200, tradeCount: 2, profit: 200, loss: 0, winCount: 2, lossCount: 0, drawCount: 0 },
  ],
  PerformanceByTag: [
    { tag: 'Tendência', tradeCount: 5, winCount: 4, lossCount: 1, winRate: 80, avgProfit: 45.2, totalPnL: 226 },
    { tag: 'Reversão', tradeCount: 3, winCount: 1, lossCount: 2, winRate: 33.3, avgProfit: -18.5, totalPnL: -55.5 },
    { tag: 'Notícias', tradeCount: 2, winCount: 2, lossCount: 0, winRate: 100, avgProfit: 90, totalPnL: 180 },
  ],
};
